import { render, staticRenderFns } from "./WithdrawalReviewModal.vue?vue&type=template&id=6346deca"
import script from "./WithdrawalReviewModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports